export default function MultilineText({ text }) {
  return String(text || "")
    .split(/\r?\n/)
    .map((line, index, lines) => (
      <span key={`${line}-${index}`}>
        {line}
        {index < lines.length - 1 && <br />}
      </span>
    ));
}
